import { useMemo } from 'react';

import { UpgradeProviderProps } from '../../../app/providers/upgrade/types';

import Upgrade from '../upgrade';

export default function useUpgradeApi(config: UpgradeProviderProps) {
  return useMemo(() => new Upgrade(config), [config]);
}
